import { render } from "./ClientReportesClientesDeuda.vue?vue&type=template&id=84af2590&scoped=true"
import script from "./ClientReportesClientesDeuda.vue?vue&type=script&lang=js"
export * from "./ClientReportesClientesDeuda.vue?vue&type=script&lang=js"

import "./ClientReportesClientesDeuda.vue?vue&type=style&index=0&id=84af2590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84af2590"]])

export default __exports__